import { SeverityLevel } from "@soft-db/monitoring-api-client";
import { SoftBadge } from "@soft-db/ui";
import { PropType } from "vue";

export default defineComponent({
	name: "AlertSeverityChip",
	props: {
		severity: {
			type: String as PropType<SeverityLevel>,
			required: true,
		},
	},
	setup(props) {
		const { t } = useI18n();
		const label = computed(() => {
			switch (props.severity) {
				case "error":
					return t("alert-settings.exceedance");
				case "warning":
					return t("alert-settings.warning");
				case "none":
					return t("alert-settings.noExceedance");
			}
		});
		return () => (
			<SoftBadge class="w-full" tile color={props.severity === "none" ? "info" : props.severity}>
				{label.value}
			</SoftBadge>
		);
	},
});
